export default function cleanNumber(number?: string) {
  return (number || '').replace(/[^0-9.]/g, '');
}

// allow the '+' at the start of the number
export const cleanNumberV2 = (number?: string) => (number || '').replace(/[^0-9.+]/g, '');
